import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CoingeckoService {

  constructor(private httpClient: HttpClient) { }
  // {"0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25":{"php":10.46}}
  getSlpCurrentPrice(currency:string): Observable<number> {
    const url = `https://api.coingecko.com/api/v3/simple/token_price/ethereum?contract_addresses=0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25&vs_currencies=${currency}`;

		return this.httpClient
			.get<any>(url)
			.pipe(
				map(data => {
          return data['0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25'][currency.toLowerCase()];
				})
			);

  }

  getAxsCurrentPrice(currency:string): Observable<number> {
    const url = `https://api.coingecko.com/api/v3/simple/token_price/ethereum?contract_addresses=0xbb0e17ef65f82ab018d8edd776e8dd940327b28b&vs_currencies=${currency}`;

		return this.httpClient
			.get<any>(url)
			.pipe(
				map(data => {
          return data['0xbb0e17ef65f82ab018d8edd776e8dd940327b28b'][currency.toLowerCase()];
				})
			);

  }

  getEthCurrentPrice(currency:string): Observable<number> {
    const url = `https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=${currency}`;

		return this.httpClient
			.get<any>(url)
			.pipe(
				map(data => {
          return data['ethereum'][currency.toLowerCase()];
				})
			);

  }
}
